import React, { useCallback, useEffect, useRef, useState } from 'react';
import { FaRegCommentAlt, FaShoppingCart } from 'react-icons/fa';
import './FloatingSummaryBubbles.scss';
import { useSelector } from 'react-redux';
import { useImmer } from 'use-immer';
import { useGetOrdersQuery } from '../../store/order/orderApi';
import { selectTableSessionId } from '../../store/auth/selectors';
import { Cart } from './Cart/Cart';
import { OrderStatusSummary } from './OrderStatusSummary/OrderStatusSummary';
import { useGetUserCartQuery } from '../../store/cart/cartApi';
import { EOrderItemStatus } from '../../proto/order/orderItemStatus.enum';
import { AiWaiterChat } from './aiWaiterChat/aiWaiterChat';

export const FloatingSummaryBubbles = (): React.JSX.Element => {
	const { data: cart } = useGetUserCartQuery();

	const cartItems = cart?.items ?? [];
	const numberOfItems = cartItems?.length ?? 0;
	const [cartSize, setCartSize] = useState(numberOfItems);
	const [isCartOpen, setIsCartOpen] = useState<boolean>(false);
	const [isChatOpen, setIsChatOpen] = useState<boolean>(false);
	const [{ isOrderStatusSummarySheetOpen, selectedOrderIdForSummary }, setSelectedOrderState] = useImmer<{
		isOrderStatusSummarySheetOpen: boolean;
		selectedOrderIdForSummary: string;
	}>({ isOrderStatusSummarySheetOpen: false, selectedOrderIdForSummary: null });
	const cartRef = useRef(null);
	const tableSessionId = useSelector(selectTableSessionId);
	const { data: activeOrders } = useGetOrdersQuery({ tableSessionId, statuses: [EOrderItemStatus.PENDING, EOrderItemStatus.PREPARING] });

	const handleCartChange = useCallback(() => {
		// Animate cart icon on add/remove item
		setTimeout(() => {
			cartRef.current.classList.add('cart-bounce');
			setTimeout(() => {
				cartRef.current.classList.remove('cart-bounce');
			}, 500);
		}, 500);

		setCartSize(numberOfItems);
	}, [numberOfItems]);

	useEffect(() => {
		handleCartChange();
	}, [numberOfItems, handleCartChange]);

	// const calcMinutesDifference = (utcDate: string | Date): number => {
	// 	const past = DateTime.fromJSDate(new Date(utcDate)).toUTC();
	// 	const now = DateTime.utc();
	//
	// 	const diff = now.diff(past, 'minutes').minutes;
	//
	// 	return Math.round(diff);
	// };

	const handleOpenOrderSummarySheet = (orderId: string): void => {
		setSelectedOrderState((state) => {
			state.isOrderStatusSummarySheetOpen = true;
			state.selectedOrderIdForSummary = orderId;
		});
	};

	const handleCartClick = (): void => {
		setIsCartOpen(!isCartOpen);
	};

	const handleCartDismiss = (): void => {
		setIsCartOpen(false);
	};

	const handleAiWaiterChatClick = (): void => {
		setIsChatOpen(true);
	};

	const handleAiWaiterChatDismiss = (): void => {
		setIsChatOpen(false);
	};

	const handleOrderStatusDismiss = (): void => {
		setSelectedOrderState((state) => {
			state.isOrderStatusSummarySheetOpen = false;
		});
	};

	return (
		<div className="floaters-container">
			{(activeOrders ?? []).map((order) => (
				<div key={order.id} className="floating-item" onClick={(): void => handleOpenOrderSummarySheet(order.id)}>
					<img src="/images/timer.png" alt="wait" />
					{/* {calcMinutesDifference(order.createdAt)} */}
				</div>
			))}
			<div className="cart-summary" onClick={handleCartClick}>
				<div className="cart-icon-container" ref={cartRef}>
					<FaShoppingCart className="cart-icon" />
				</div>
				<span className="cart-size">{cartSize}</span>
			</div>
			<div className="ai-waiter-chat" onClick={handleAiWaiterChatClick}>
				<div className="cart-icon-container" ref={cartRef}>
					<FaRegCommentAlt className="cart-icon" />
				</div>
			</div>
			<AiWaiterChat onDismiss={handleAiWaiterChatDismiss} isOpen={isChatOpen} />
			<Cart onDismiss={handleCartDismiss} isOpen={isCartOpen} />
			<OrderStatusSummary onDismiss={handleOrderStatusDismiss} isOpen={isOrderStatusSummarySheetOpen} orderId={selectedOrderIdForSummary} />
		</div>
	);
};
